import { AmenitySvg, AmenitySvgProps } from "./AmenitySvg";

export function InternetAndSignalIcon(props: AmenitySvgProps) {
  return (
    <AmenitySvg {...props}>
      <path
        d="M6 14.8584C6 10.282 6 7.99376 7.38674 6.54394C7.43797 6.49038 7.49038 6.43797 7.54394 6.38674C8.99376 5 11.282 5 15.8584 5C16.943 5 17.4655 5.00376 17.9628 5.18936C18.4417 5.3681 18.8429 5.70239 19.6452 6.37099L21.8411 8.20092C22.9027 9.08561 23.4335 9.52795 23.7168 10.1327C24 10.7374 24 11.4283 24 12.8102V16C24 19.7497 24 21.6246 23.0451 22.9389C22.7367 23.3634 22.3634 23.7367 21.9389 24.0451C20.6246 25 18.7497 25 15 25C11.2503 25 9.3754 25 8.06107 24.0451C7.6366 23.7367 7.26331 23.3634 6.95491 22.9389C6 21.6246 6 19.7497 6 16V14.8584Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M10 17.5C10 19.1499 10 19.9749 10.4393 20.4874C10.8787 21 11.5858 21 13 21H17C18.4142 21 19.1213 21 19.5607 20.4874C20 19.9749 20 19.1499 20 17.5M10 17.5C10 15.8501 10 15.0251 10.4393 14.5126C10.8787 14 11.5858 14 13 14H17C18.4142 14 19.1213 14 19.5607 14.5126C20 15.0251 20 15.8501 20 17.5M10 17.5H12M20 17.5H18"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </AmenitySvg>
  );
}
